module.exports = __webpack_public_path__ + "img/imam-hussain-logo.b6ee5d9b.svg";